<template>
  <div class="gw-column g-fill">
		<!-- <div id="blog-column" class="gw-column"> -->
			<div class="gw-box shadow">
				<div class="gw-box-body center-h font-lg">
					<!-- <img src="../assets/WUAS long logo2.png" class="ws-logo-image gui-reactive-lg gui-reactive-md">
					<img src="../assets/WS Logo.png" class="ws-logo-image-sm gui-reactive-sm"> -->
					
					<div class="pad-lg"></div>
					
					<p><span class="glyphicon glyphicon-star question-glyphicon"></span>Are you looking for a way to give your special event elegance?</p>
					<p><span class="glyphicon glyphicon-star question-glyphicon"></span>Do you need soft, beautiful music for your wedding or reception?</p>
					<p><span class="glyphicon glyphicon-star question-glyphicon"></span>Do you want to impress your friends at your next dinner party?</p>
					<p><span class="glyphicon glyphicon-star question-glyphicon"></span>Have you always dreamed of playing the harp?</p>
					
					<div class="gw-spacer"></div>
					<p>If you answered YES to any of these questions, <b>AimeeOnTheHarp</b> can help!</p>
					
					<div class="quote-spacer gw-row center-h md lg">
						<button class="request-a-quote-button gw-box shadow lg" @click="openQuoteDialog">Request a Quote</button>
					</div>
					
					<p>To discuss booking me for your event, click the <b>Request a Quote</b> button above and fill out the form.</p>
					<p>If you have any questions, email me at <a href="mailto:aimee@aimeeontheharp.com">aimee@aimeeontheharp.com</a> or call me at <a href="tel:+14109695789">410-969-5789</a>.</p>
				</div>
			
				
			</div>
			<div class="gw-box shadow" v-if="events.length > 0">
				<div class="gw-box-header">
					<h4 id="upcoming-events-title">Upcoming Public Events</h4>
				</div>
				<div class="gw-box-body">
					<div class="public-event" v-for="(event, i) in events" :key="i">
						<hr>
						<div class="event-name">{{event.name}}</div>
						<div class="event-date">{{event.date}}</div>
						<div class="event-location-label">Location:</div>
						<div class="event-location">{{event.location}}</div>
						<div class="event-address">{{event.address}}</div>
					</div>
				</div>
			</div>
		<!-- </div> -->
	</div>
</template>

<script>
import { bus } from '@/main'

export default {
	name: 'Home',
	
  data() {
    return {
			events: []
    }
	},
	
	methods: {
		openQuoteDialog: function() {
			bus.$emit('open-quote-dialog');
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.quote-spacer {
	margin: 50px auto;
}

.request-a-quote-button {
	font-size: 20px;
	padding: 16px 60px;
}

p {
	line-height: 1.5;
	margin-bottom: 20px;
	font-size: 16px;
}

p:last-of-type {
	margin-bottom: 0;
}

.center-h {
	text-align: center;
}
</style>
